import { BlocksIconEditBox } from 'blocks-nextjs/blocks-web-components/components/icon/icons/edit-box';
import React from 'react';
import { createComponent } from '../../CustomWrapper/CustomWrapper';

export const CatIconEditBox = createComponent({ react: React, tagName: 'cat-icon-edit-box', elementClass: BlocksIconEditBox });
